import React from 'react';
import styled from 'styled-components';
import { Input, Select, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { PiFunnelBold, PiSortAscendingBold } from 'react-icons/pi';

interface CollectFormTemplateFiltersProps {
  searchText: string;
  onSearchChange: (value: string) => void;
  sqliteFilter: 'all' | 'has_sqlite' | 'no_sqlite';
  onSqliteFilterChange: (value: 'all' | 'has_sqlite' | 'no_sqlite') => void;
  sortBy: 'date_desc' | 'date_asc' | 'name_asc' | 'name_desc';
  onSortByChange: (value: 'date_desc' | 'date_asc' | 'name_asc' | 'name_desc') => void;
}

export const CollectFormTemplateFilters: React.FC<CollectFormTemplateFiltersProps> = ({
  searchText,
  onSearchChange,
  sqliteFilter,
  onSqliteFilterChange,
  sortBy,
  onSortByChange,
}) => {
  return (
    <UI_FiltersWrapper>
      <UI_SearchSection>
        <Input
          placeholder="Tìm kiếm mẫu biểu mẫu theo tên, mô tả..."
          prefix={<SearchOutlined style={{ color: '#94a3b8' }} />}
          allowClear
          value={searchText}
          onChange={(e) => onSearchChange(e.target.value)}
          style={{ width: '100%', maxWidth: 360, borderRadius: 6 }}
        />
      </UI_SearchSection>

      <UI_FilterGroup>
        <Space size={10} wrap>
          <UI_FilterItem>
            <PiFunnelBold size={14} color="#64748b" />
            <Select
              value={sqliteFilter}
              onChange={onSqliteFilterChange}
              style={{ width: 170 }}
              options={[
                { value: 'all', label: 'Tất cả biểu mẫu' },
                { value: 'has_sqlite', label: 'Có SQLite đính kèm' },
                { value: 'no_sqlite', label: 'Không có SQLite' },
              ]}
            />
          </UI_FilterItem>

          <UI_FilterItem>
            <PiSortAscendingBold size={14} color="#64748b" />
            <Select
              value={sortBy}
              onChange={onSortByChange}
              style={{ width: 160 }}
              options={[
                { value: 'date_desc', label: 'Mới nhất' },
                { value: 'date_asc', label: 'Cũ nhất' },
                { value: 'name_asc', label: 'Tên (A-Z)' },
                { value: 'name_desc', label: 'Tên (Z-A)' },
              ]}
            />
          </UI_FilterItem>
        </Space>
      </UI_FilterGroup>
    </UI_FiltersWrapper>
  );
};

const UI_FiltersWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  background-color: #f8fafc;
  border-bottom: 1px solid #f1f5f9;
  gap: 12px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const UI_SearchSection = styled.div`
  flex: 1;
`;

const UI_FilterGroup = styled.div`
  display: flex;
  align-items: center;
`;

const UI_FilterItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;
